

































































import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { IUser, UserStatus } from 'admiral-core';
import { UsersIcon, CheckIcon, XIcon } from 'vue-feather-icons';
import Avatar from '@/components/common/Avatar.vue';

@Component({
  name: 'TaskUserFilter',
  components: {
    UsersIcon,
    CheckIcon,
    XIcon,
    Avatar,
  },
})
export default class TaskUserFilter extends mixins(BaseMixin) {
  @Prop({ type: Array, default: () => [] })
  selectedUsers!: IUser[];

  hovered = false;

  get otherUsers(): IUser[] {
    if (!this.user) return [];
    return (this.users || []).filter(
      (u) => u.id !== this.user.id && u.status === UserStatus.ACTIVE,
    );
  }

  get isTeamSelected(): boolean {
    if (this.otherUsers.length === 0) return false;
    return this.otherUsers.every((u) => this.isSelected(u));
  }

  get displayLabel(): string {
    if (this.selectedUsers.length === 0) return 'Alle Mitarbeiter';
    if (this.selectedUsers.length === 1) return this.userDisplayName(this.selectedUsers[0]);
    return `${this.userDisplayName(this.selectedUsers[0])} + ${this.selectedUsers.length - 1}`;
  }

  userDisplayName(u: IUser): string {
    return [u.firstname, u.lastname].filter(Boolean).join(' ') || 'Unbekannt';
  }

  isSelected(u: IUser): boolean {
    return this.selectedUsers.some((selected) => selected.id === u.id);
  }

  toggleUser(u: IUser) {
    const isSelected = this.isSelected(u);
    const newUsers = isSelected
      ? this.selectedUsers.filter((selected) => selected.id !== u.id)
      : [...this.selectedUsers, u];
    this.$emit('update:users', newUsers);
  }

  toggleTeam() {
    this.$emit('update:users', []);
  }

  clearFilter() {
    this.$emit('update:users', []);
  }

  async mounted() {
    if ((!this.users || this.users.length === 0) && this.user?.agency) {
      await this.fetchUsers();
    }
  }
}
